import { ActionRegistry } from '../registry/ActionRegistry';
import {
  ClickActionHandler,
  FillInputActionHandler,
  WaitActionHandler,
  WaitForElementActionHandler,
  SelectOptionActionHandler,
  CustomActionHandler,
} from './actionHandlers';

/**
 * Factory function to create a registry with all default action handlers
 */
export function createDefaultActionRegistry(): ActionRegistry {
  const registry = new ActionRegistry();

  // Register all built-in handlers
  registry.register('click', new ClickActionHandler());
  registry.register('fill-input', new FillInputActionHandler());
  registry.register('wait', new WaitActionHandler());
  registry.register('wait-for', new WaitForElementActionHandler());
  registry.register('select-option', new SelectOptionActionHandler());
  registry.register('custom', new CustomActionHandler());

  return registry;
}
